/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ebr_Diff_Unchanged_CharsInputs */

const cs_ebr_diff_unchanged_chars = /** @type {(inputs: Ebr_Diff_Unchanged_CharsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} znaků beze změny — rozbalit`)
};

const en_ebr_diff_unchanged_chars = /** @type {(inputs: Ebr_Diff_Unchanged_CharsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unchanged characters — expand`)
};

/**
* | output |
* | --- |
* | "{count} unchanged characters — expand" |
*
* @param {Ebr_Diff_Unchanged_CharsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_unchanged_chars = /** @type {((inputs: Ebr_Diff_Unchanged_CharsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_Unchanged_CharsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_unchanged_chars(inputs)
	return cs_ebr_diff_unchanged_chars(inputs)
});